import { fabric } from 'fabric';
import DEFINE from '../define';
import ToolBase from '../basic';
import EventBus from '../../event_bus';
import AppRenderer from "../../app_renderer";
import edit_pen from '../../../assets/other_tools/web_link/edit_pen.svg';
import link_title from '../../../assets/other_tools/web_link/link_title.svg';

export default class insertWebLink extends ToolBase {

    name = DEFINE.TOOLS.INSERT_WEB_LINK;

    point = {
        x: 0,
        y: 0,
    };

    constructor(parent) {
        super(parent);
    }

    recover(object) {
        let self = this;
        let group = object;

        this.point = {
            x: group.aCoords.bl.x,
            y: group.aCoords.bl.y
        }

        let objTxt = null;
        let objEditPen = null;
        let objLinkTitle = null;

        group.setCoords();

        group.forEachObject((obj, index) => {
            switch (obj.data.type) {
                case DEFINE.TAG.INSERT_WEB_LINK_TEXT:
                    objTxt = obj;
                    console.log(obj);
                    break;
                case DEFINE.TAG.INSERT_WEB_LINK_EDIT_PEN:
                    objEditPen = obj;

                    objEditPen.set({
                        tag: DEFINE.TAG.INSERT_WEB_LINK_EDIT_PEN + new Date().getTime(),
                        data: { type: DEFINE.TAG.INSERT_WEB_LINK_EDIT_PEN },
                    });

                    objEditPen.on("mouseup", () => {

                        if (group.isDown == false) {
                            return;
                        }

                        if (group.isDarg == true) {
                            group.isDown = false;
                            return;
                        }

                        //傳值給Vue
                        this.sendJsToVue(DEFINE.TAG.INSERT_WEB_LINK_EDIT_PEN, group);
                    })
                    break;
                case DEFINE.TAG.INSERT_WEB_LINK_TITLE:
                    objLinkTitle = obj;
                    objLinkTitle.set({
                        tag: DEFINE.TAG.INSERT_WEB_LINK_TITLE + new Date().getTime(),
                        data: { type: DEFINE.TAG.INSERT_WEB_LINK_TITLE },
                        objGroup: group,
                    });

                    objLinkTitle.on("mouseup", () => {

                        if (group.isDown == false) {
                            return;
                        }

                        if (group.isDarg == true) {
                            group.isDown = false;
                            return;
                        }

                        //傳值給Vue
                        this.sendJsToVue(DEFINE.TAG.INSERT_WEB_LINK_TITLE, group);
                    })
                    break;
            }
        });

        group.set({
            point: this.point,
            hasControls: false,
            hasBorders: false,
            subTargetCheck: true,
            objTxt: objTxt,
            objEditPen: objEditPen,
            objLinkTitle: objLinkTitle,
        });

        group.objTxt.set({
            left: group.x + (group.objTxt.width / 2),
        });

        this.registerEvent(group);
    }

    mouseDown(o) {
        const self = this;

        let pointer = this.canvas.getPointer(o.e);
        this.parent.proxy.changeTool(null);

        this.point = {
            x: pointer.x,
            y: pointer.y
        };

        let titleText = new fabric.Text("測試你我他")
        let linkTitle = null;
        let editPen = null;
        let group = null;
        let loadTime = 0;

        titleText.set({
            data: { type: DEFINE.TAG.INSERT_WEB_LINK_TEXT },
            fontSize: 20,
            left: this.point.x,
            top: this.point.y + 50
        });

        fabric.loadSVGFromURL(link_title, (objects, options) => {
            linkTitle = new fabric.util.groupSVGElements(objects, options);

            linkTitle.set({
                tag: DEFINE.TAG.INSERT_WEB_LINK_TITLE + + new Date().getTime(),
                data: { type: DEFINE.TAG.INSERT_WEB_LINK_TITLE },
                left: this.point.x,
                top: this.point.y,
                objGroup: group
            });

            linkTitle.on("mouseup", () => {
                if (group.isDown == false) {
                    return;
                }
    
                if (group.isDarg == true) {
                    group.isDown = false;
                    return;
                }
    
                //傳值給Vue
                self.sendJsToVue(DEFINE.TAG.INSERT_WEB_LINK_TITLE, group);
    
                group.isDown = false;
            })
        });

        fabric.loadSVGFromURL(edit_pen, (objects, options) => {
            editPen = new fabric.util.groupSVGElements(objects, options);

            editPen.set({
                tag: DEFINE.TAG.INSERT_WEB_LINK_TITLE + new Date().getTime(),
                data: { type: DEFINE.TAG.INSERT_WEB_LINK_EDIT_PEN },
                left: this.point.x + 55,
                top: this.point.y,
                objGroup: group
            });

            editPen.on("mouseup", () => {
                if (group.isDown == false) {
                    return;
                }
    
                if (group.isDarg == true) {
                    group.isDown = false;
                    return;
                }
    
                //傳值給Vue
                self.sendJsToVue(DEFINE.TAG.INSERT_WEB_LINK_EDIT_PEN, group);
    
                group.isDown = false;
            })
        });

        let intervalId = setInterval(() => {
            loadTime += 50;
            if (titleText && linkTitle && editPen) {
                clearInterval(intervalId);

                group = this.addToGroup([titleText, linkTitle, editPen]);
                group.set({
                    toolType: this.name,
                    tag: DEFINE.TAG.INSERT_WEB_LINK + new Date().getTime(),
        
                    point: this.point,
                    data: {
                        url: "",
                        titleName: "",
                        type: DEFINE.TAG.INSERT_WEB_LINK
                    },
        
                    isDown: false,
                    isDarg: false,
        
                    objTxt: titleText,
                    objEditPen: editPen,
                    objLinkTitle: linkTitle,
                });

                titleText.set("text", "");

                this.registerEvent(group);

                EventBus.getInstance().emit("sendWebLink", {
                    type: DEFINE.TAG.INSERT_WEB_LINK_EDIT_PEN,
                    arg: group
                });
            } else if (loadTime >= 10000) {
                clearInterval(intervalId);
            }
        }, 50);
    }

    registerEvent(group) {
        group.set("updateData", this.updateData());
        group.set("remove", this.remove(group));

        group.on("mousedown", () => {
            group.isDarg = false;
            group.isDown = true;
        });

        group.on("moving", () => {
            group.isDarg = true;
            group.isDarg = true;
        });

        group.set({
            hasControls: false,
            hasBorders: false,
            subTargetCheck: true,
        });
    }

    sendJsToVue(type, objGroup) {
        switch (type) {
            case DEFINE.TAG.INSERT_WEB_LINK_EDIT_PEN:
                console.log(objGroup);
                EventBus.getInstance().emit("sendWebLink", {
                    type: type,
                    arg: objGroup
                });
                break;
            case DEFINE.TAG.INSERT_WEB_LINK_TITLE:
                let openUrl = (url) => {
                    AppRenderer.Instance.openWebSite(url);
                };

                EventBus.getInstance().emit("sendWebLink", {
                    type: type,
                    arg: objGroup,
                    callBack: openUrl
                });
                break;
        }
    }
    
    updateData() {
        const self = this;
        return(target, newUrl, newTitle) => {
            target.data.url = newUrl;
            target.data.titleName = newTitle;

            console.log("set new value to target:", target);
    
            if (target.objTxt != null) {
                target.objTxt.set("text", newTitle);
    
                target.objTxt.set({
                    left: target.objEditPen - 10 - (target.objTxt.width / 2),
                });
    
                self.canvas.renderAll();
    
                self.parent.addHistory();
            }
        }
    }

    remove(target) {
        const self = this;
        return () => {
            console.log("remove:", target);
            self.canvas.remove(target);
        }
    }
}